import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'preview', 'dimensions']
  static values = {
    default: { type: Number },
    mobileOffset: { type: Number }
  }

  connect () {
    this.update()
    if (this.hasPreviewTarget) {
      this.previewTarget.addEventListener('load', () => this.updateDimensions())
    }
  }

  update () {
    const desktopWidth = parseInt(this.inputTarget.value) || this.defaultValue
    const mobileWidth = desktopWidth - this.mobileOffsetValue
    this.previewTarget.style.setProperty('--simulator-logo-max-width-desktop', `${desktopWidth}px`)
    this.previewTarget.style.setProperty('--simulator-logo-max-width-mobile', `${mobileWidth}px`)
    this.updateDimensions()
  }

  updateDimensions () {
    if (!this.hasDimensionsTarget || !this.hasPreviewTarget) return
    window.requestAnimationFrame(() => {
      const rect = this.previewTarget.getBoundingClientRect()
      const w = Math.round(rect.width)
      const h = Math.round(rect.height)
      this.dimensionsTarget.textContent = `${w} x ${h} px`
    })
  }
}
